import ru from './ru'
import oz from './oz'
import en from './en'

export default {
  ru,
  oz,
  en
}